<div class="algorith-section-title">
    <div class="title">
        Algorithm
    </div>
    <div class="note">
        Note: select from the available list of Algorithm.
    </div>
</div>
<div class="algorith-section-content">
    <p class="label">Algorithm<span class="required"  *ngIf="selectedValue?.value === '' || selectedValue?.value === null && mode === CONFIG_MODE.CREATE">*</span></p>
    <form [formGroup]="algorithmForm" class="algoForm">
        <mat-form-field>
            <mat-select formControlName="algorithm" disableOptionCentering>
                <mat-option selected disabled [value]="selectedValue" [style.display]="true ? 'none' : 'block'">
                    {{selectedValue == undefined ? '' : selectedValue.modelName}}
                </mat-option>
                <mat-option *ngFor="let option of algorithmList" [value]="option">
                    {{option.modelName}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</div>
